import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import clsx from 'clsx';
const Slider = (props) => {
    const { renderButtons, infinite = false, autoPlay, autoPlaySpeed = 1500, pauseOnHover, sliderWrapperClasses, scrollSpeed = 20, children, align, childrenWrapperClass, } = props;
    const sliderRef = useRef(null);
    const [viewportRef, embla] = useEmblaCarousel({
        skipSnaps: false,
        speed: scrollSpeed,
        align: align || 'start',
        containScroll: 'trimSnaps',
        draggable: true,
        dragFree: true,
        ...{ loop: infinite },
    });
    const [prevBtnEnabled, setPrevBtnEnabled] = useState(infinite);
    const [nextBtnEnabled, setNextBtnEnabled] = useState(infinite);
    const [disableSlider, setDisableSlider] = useState(false);
    const sliderBtnRef = useRef({
        nextBtnEnabled: false,
        prevBtnEnabled: false,
    });
    const sliderAutoPlayRef = useRef(null);
    const scrollPrev = () => embla && embla.scrollPrev();
    const scrollNext = () => embla && embla.scrollNext();
    const onSelect = () => {
        if (!embla) {
            return;
        }
        const prev = embla.canScrollPrev();
        const next = embla.canScrollNext();
        if (sliderBtnRef.current.prevBtnEnabled !== prev) {
            sliderBtnRef.current.prevBtnEnabled = prev;
            setPrevBtnEnabled(prev);
        }
        if (sliderBtnRef.current.nextBtnEnabled !== next) {
            sliderBtnRef.current.nextBtnEnabled = next;
            setNextBtnEnabled(next);
        }
    };
    const autoPlayToNextSlide = () => {
        if (!embla || !document.hasFocus()) {
            return;
        }
        if (embla?.canScrollNext()) {
            embla?.scrollNext();
        }
        else {
            embla?.scrollTo(0);
        }
        sliderAutoPlayRef.current = setTimeout(autoPlayToNextSlide, autoPlaySpeed);
    };
    useEffect(() => {
        if (!embla) {
            return;
        }
        if (renderButtons) {
            embla.on('select', onSelect);
            onSelect();
        }
        if (autoPlay) {
            setTimeout(autoPlayToNextSlide, autoPlaySpeed);
        }
        if (!sliderBtnRef.current.prevBtnEnabled &&
            !sliderBtnRef.current.nextBtnEnabled) {
            setDisableSlider(true);
        }
    }, [embla]);
    const toggleAutoplay = (play) => {
        if (!embla) {
            return;
        }
        if (pauseOnHover) {
            if (play) {
                clearTimeout(sliderAutoPlayRef.current);
            }
            else {
                sliderAutoPlayRef.current = setTimeout(autoPlayToNextSlide, autoPlaySpeed);
            }
        }
    };
    return (_jsxs("div", { onMouseOver: () => toggleAutoplay(true), onMouseLeave: () => toggleAutoplay(false), onTouchStart: () => toggleAutoplay(true), onTouchEnd: () => toggleAutoplay(false), className: clsx('iv-relative', sliderWrapperClasses), children: [_jsx("div", { ref: viewportRef, children: _jsx("div", { className: clsx('iv-flex', disableSlider && 'iv-justify-center', childrenWrapperClass), ref: sliderRef, children: children }) }), renderButtons &&
                renderButtons(scrollPrev, scrollNext, !prevBtnEnabled, !nextBtnEnabled)] }));
};
export default Slider;
